import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { useTranslation } from 'next-i18next'
import * as styles from './style'

export interface Props {
  actionLabel?: string
  url?: string
  partnerLogo?: string
  partnerName?: string
}

const WelcomeContent = ({ actionLabel = 'Next', url, partnerLogo, partnerName }: Props): JSX.Element => {
  const { t } = useTranslation('partner')
  return (
    <Layout>
      <Stack y>
        <Stack x className={`${styles.logoContainer} p-sm`}>
          <div className={`${styles.rightBorder} pl-md pr-md`}>
            <img className={styles.logo} src="/images/gsu-logo.png" loading="lazy" />
          </div>
          <div className="pl-md pr-md">
            <img className={styles.logo} src={partnerLogo} loading="lazy" />
          </div>
        </Stack>

        <Stack y className="mt-lg ta-c">
          <Text size="md" tag="p" weight="md">
            {t('welcomeContent.welcomeNote')}
          </Text>
          <Text size="xxs" tag="p" weight="sm">
            {t('welcomeContent.thankyouNote', { partnerName })}
          </Text>
        </Stack>
        <div className="pt-lg pb-sm">
          <img src="/images/green-tick.svg" loading="lazy" />
        </div>

        <div className={styles.actions}>
          <Button component="link" href={url} theme="primary" label={actionLabel} size="lg" stretch />
        </div>
      </Stack>
    </Layout>
  )
}
export default WelcomeContent
